export default "__VITE_ASSET__20c9f220__"